import { render } from "./_ResearchProjects.vue?vue&type=template&id=74c19ce7&scoped=true&lang=en"
import script from "./_ResearchProjects.vue?vue&type=script&lang=js"
export * from "./_ResearchProjects.vue?vue&type=script&lang=js"

import "./_ResearchProjects.vue?vue&type=style&index=0&id=74c19ce7&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c19ce7"]])

export default __exports__